import React from 'react';
import { useNotification } from '../../context/NotificationContext';
import Notification from './Notification';

const GlobalNotificationDisplay: React.FC = () => {
  const { notifications, hideNotification } = useNotification();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="global-notifications" style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 9999,
      maxWidth: '400px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          type={notification.type}
          message={notification.message}
          onClose={() => hideNotification(notification.id)}
          autoClose={false} // We handle auto-close in the context
          duration={notification.duration}
        />
      ))}
    </div>
  );
};

export default GlobalNotificationDisplay;
